import React, { forwardRef, useCallback, useImperativeHandle, useMemo, useRef } from "react";
import { Form, message } from "antd";
import { FieldTypes, nameRegexValidator } from "utils/formUtils";
import { duplicateNameValidator } from "utils/validatorUtil";
import _, { omit } from "lodash";
import ToolsIntegrationsAPI from "restAPI/ToolsIntegrationAPI";
// import ModalUtil from "utils/modalUtil";
import { MODAL_SIZE_MEDIUM } from "constants/Layout";
import BaseModalForm from "components/BaseModalForm";

function FlashPointConfigForm({ name, displayName, loginConfigList, ...props }, ref) {
  const isEdit = !_.isUndefined(props.config);
  const [form] = Form.useForm();
  const thisRef = useRef();

  useImperativeHandle(ref, () => ({
    ...thisRef,
  }));

  const onOk = useCallback(async () => {
    await form.validateFields();
    try {
      let payload = form.getFieldsValue();
      payload = {
        ...payload,
        configType: "FLASH_POINT",
        config:{
            client_id: payload.client_id,
            client_secret: payload.client_secret,
        }
      };
      payload = omit(payload, ['baseUrl', 'accessId', 'secretKey', 'tql']);
    //   const configUrl = !isEdit ? "postCTILoginDetails" : "updateTicketSystemToolLoginDetails";

      await ToolsIntegrationsAPI.postCTILoginDetails(payload, props.config?.id).promise;

      message.success(`${name} Login Configuration created`);
    //show mapping form 
    //currently no mapping form
    //   if (!isEdit) {
    //     ModalUtil.show({
    //       content: (
    //          <MappingFormComponent
    //           onUpdateConfigComponent={props.onUpdateConfigComponent}
    //           name={name}
    //           loginConfigId={response.id}
    //           displayName={displayName}
    //         />
    //       ),
    //     });
    //   }
      props.onUpdateConfigComponent && props.onUpdateConfigComponent(true);
    } catch (err) {
      console.log(err);
      if (!_.isEmpty(err.response.data.errors)) {
        const { field, defaultMessage } = err.response?.data?.errors[0];
        form.setFields([
          {
            name: field,
            errors: [defaultMessage],
          },
        ]);
      }
      return Promise.reject(err.response?.data?.message);
    }
  },[form, name, props]);

  const modalProps = {
    title: (
      <>
        {isEdit ? "Edit" : "Add"} {displayName} Login Credentials{" "}
      </>
    ),
    width: MODAL_SIZE_MEDIUM,
  };

  const fields = useMemo(
    () => [
      {
        name: "name",
        label: "Name",
        colSpan: 12,
        required: true,
        props: {
          autoFocus: true,
        },
        rules: [
          duplicateNameValidator({ list: loginConfigList }),
          nameRegexValidator,
        ],
      },
      {
        name: "client_id",
        label: "Client Id",
        type: FieldTypes.PASSWORD,
        colSpan: 12,
        required: true,
      },
      {
        name: "client_secret",
        label: "Client Secret",
        type: FieldTypes.PASSWORD,
        colSpan: 12,
        required: true,
      },
    ],
    [loginConfigList]
  );

  return (
    <BaseModalForm
      modalProps={modalProps}
      ref={thisRef}
      afterClose={props.afterClose}
      fields={fields}
      form={form}
      initialValues={props.config}
      onOk={onOk}
    />
  );
}

export default forwardRef(FlashPointConfigForm);
